<div class="device-registration-wrapper">
	<div class="main-wrapper">
		<div>
			<div class="goBack">
				<app-back-navigation-button (goBack)="goBack()" buttonName="Go to login">
				</app-back-navigation-button>
			</div>
			<div class="device-reg">
				<div class="title">
					Enter OTP
				</div>
				<div class="note">
					We’ve just sent a 6-digit code to your registered
					phone number. Enter the code to proceed
				</div>
			</div>
		</div>
	</div>
	<div class="otp-container">
		<div class="device-registration-container">
			<nz-layout>
				<nz-header></nz-header>
				<nz-content>
					<div>
						<app-password-input-box (emitInput)="onInputChange($event)">
						</app-password-input-box>
					</div>
					<div class="m-t-5" nz-row nzJustify="end">
						<app-otp-count-down
							(emitRetryAction)="retryOtp()"
							[countdownType]="countdownType.KAMONA"
							[expiryTime]="expiryTime">
						</app-otp-count-down>
					</div>
					<div class="m-t-24">
						<app-ussd-board [ussdCode]="ussdCode"></app-ussd-board>
					</div>
				</nz-content>
				<nz-footer>
					<div nz-row nzJustify="center">
						<div class="kamona-button-session" nz-col
							 nzSpan="24">
							<app-kamona-custom-button
								(submitForm)="submit()"
								[isBlock]="true"
								[isDisabled]="!disableButton"
								[isSubmitting]="submitting"
								[state]="'primary'" text="Next">
							</app-kamona-custom-button>
						</div>
					</div>
				</nz-footer>
			</nz-layout>
		</div>
	</div>
</div>

